import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";
import { data } from 'jquery';

const NcsMeetingList = ({
    getNcsMeetings,
    ncsMeetings,
    history,
    match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [remark, setRemark] = useState("");
  const [closed, setClosed] = useState(false);
  const [listDataComplete, setListDataComplete] = useState();

  useEffect(() => {
    if (getNcsMeetings !== null){
        (async () => {
            setIsLoading(true);
            const res = await getNcsMeetings();
            if(res) {
              console.log(res);
            }
            setIsLoading(false);
          })();
    }
      
  }, [getNcsMeetings]); 

  const headers = [
    'Account  Id',
    'Account Name',
    'Account Address',
    // 'Site Number',
    'Assigned To',
    'Status',
    'Action' 
  ];

  useEffect(() => {
    const tableData = [
        'id',
        'account_id',
        'client_name',
        'address_1',
        // 'site_number',
        'name',
        'status',
        'Action'
    ];
    console.log('here' , ncsMeetings);
    if (ncsMeetings && ncsMeetings?.open && ncsMeetings?.open?.length > 0) {
        const data = ncsMeetings?.open?.map((element) =>
            Object.assign(
                {},
                ...tableData.map((key) => ( 
                   {[key]: element[key]}           
                  )
                ),
                {
                  Action: [
                    {
                      name: 'Mark Complete',
                      link: `${baseUrl}/ncs-meeting-complete`,
                    }
                  ]
                }
            )
        );  
        data && setListData(data);
        setPageCount(Math.ceil(ncsMeetings.total / ncsMeetings.per_page));
    }
  }, [ncsMeetings]);

  const headers2 = [
    'Account  Id',
    'Account Name',
    'Account Address',
    // 'Site Number',
    'Assigned To',
    'Status',
    'Action' 
  ];

  useEffect(() => {
    const tableData = [
        'id',
        'account_id',
        'client_name',
        'address_1',
        // 'site_number',
        'name',
        'status',
        'Action' 
    ];
    console.log('here' , ncsMeetings);
    if (ncsMeetings && ncsMeetings?.complete && ncsMeetings?.complete?.length > 0) {
        const data = ncsMeetings?.complete?.map((element) =>
            Object.assign(
                {},
                ...tableData.map((key) => ( 
                   {[key]: element[key]}           
                  )
                ),
                {
                  Action: [
                    {
                      name: 'View Details',
                      link: `${baseUrl}/view-meeting-complete`,
                    }
                  ]
                }
            )
        );  
        data && setListDataComplete(data);
        setPageCount(Math.ceil(ncsMeetings.total / ncsMeetings.per_page));
    }
  }, [ncsMeetings]);

  const onPageChange = async (val) => {
    // setIsLoading(true);
    // await getAllIncentives(val.selected + 1);
    // setIsLoading(false);
  };

  return (
    <Layout
      title={localization.ncsMeetings}
      // Buttons={headerBtns}
      isLoading={isLoading}
    >

    <div className="container-fluid">
      <div className="card mt-2">
        <div className="card-header">
          {`Pending Meetings`}
        </div>
          <div className="card-header">
           <div className="card-body">
            <TableSection
              data={listData}
              // data={listData}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={pageCount}
              onPageChange={onPageChange}
              //onChange={(data) => {updateApproval(data)}}
              detailList={listData && listData}
              srNo={ncsMeetings?.open?.from}
              hideImage={true}
            />
           </div>
          </div>
        </div>
        <div className="card mt-2">
        <div className="card-header">
          {`Complete Meetings`}
        </div>
          <div className="card-header">
           <div className="card-body">
            <TableSection
              data={listDataComplete}
              // data={listData}
              isId={false}
              isMngId={false}
              headers={headers2}
              pageCount={pageCount}
              onPageChange={onPageChange}
              //onChange={(data) => {updateApproval(data)}}
              detailList={listDataComplete && listDataComplete}
              srNo={ncsMeetings?.complete?.from}
              hideImage={true}
            />
           </div>
          </div>
        </div>
      </div>

      {/* <ModalPop
          title={
          actionData && actionData.action === 'reject'
              ? localization.rejectConf
              : localization.conf
          }
          show={isModal}
          handleModalHide={handleModalHide}
          actionData={actionData}
      >
      {actionData && actionData.action === 'reject' ? (
      <Fragment>
          <div className="modal-body">
          <div className="text-center">
              <h5>{localization.rejectIncentive}</h5>
              <div className="form-group">
              <ConstantInput
                  label={localization.addRemark}
                  required
                  isStarRequired={true}
                  type="text"
                  handleChange={(val) => {
                  setRemark(val);
                  }}
              />
              </div>
              <Button
              className="btn btn-primary"
              onClick={handleContinue}
              disabled={!remark}
              >
              {localization.continue}{' '}
              <img src="../images/arrow-right.png" alt="" />
              </Button>
          </div>
          </div>
      </Fragment>
      ) : (
      <Fragment>
          {successIconBox(localization.approvencsMeetingscccess, handleModalHide)}
      </Fragment>
      )}
      </ModalPop> */}
     
    </Layout>
  );
};

export default NcsMeetingList;
